import { useGetFetch } from '../../utils/reactQuery';
import { pathToUrl } from '../../utils/router';
import { ApiRoutesEnum } from '../../utils/routes';
import { ReminderType } from '../recruitment-details/useGetRecruitmentReminders';

export type FetchRemindersResponseType = {
  count: number;
  results: ReminderType[];
};

export const useGetCandidateReminders = (id: string) =>
  useGetFetch<FetchRemindersResponseType>({
    url: pathToUrl(ApiRoutesEnum.getCandidateReminders, { id }),
    config: { enabled: !!id },
  });
